<template>
  <div :id="id" :class="className" :style="{height:height,width:width}"/>
</template>

<script>
  import echarts from 'echarts'

  export default {
    name: 'line-charts',
    props: {
      className: {
        type: String,
        default: 'chart'
      },
      id: {
        type: String,
        default: 'chart'
      },
      width: {
        type: String,
        default: '100%'
      },
      height: {
        type: String,
        default: '235px'
      },
      chartData: {
        type:Object,
        required:true
      },
    },
    data() {
      return {
        chart: null
      }
    },
    computed:{
      isCollapsed(){
        return this.$store.state.app.sidebar.clapse
      }
    },
    watch:{
      isCollapsed(){
        this.resizeCharts()
      }
    },
    mounted() {
      this.initLineCharts()
      this.resizeCharts()
      window.addEventListener('resize', () => {
        this.resizeCharts()
      })
    },
    beforeDestroy() {
      if (!this.chart) {
        return
      }
      window.removeEventListener('resize', () => {
        this.resizeCharts()
      })
      this.chart.dispose() // 销毁
      this.chart = null
    },
    methods: {
      /**
       * 重置图表
       */
      resizeCharts(){
        setTimeout(() => {
          if (this.chart) {
            this.chart.resize()
          }
        },350)
      },
      objOfValueToArr(object) {
        var arr = [];
        var i = 0;
        for (var item in object) {
          arr[i] = object[item];
          i++;
        }
        return arr;
      },
      /**
       * 初始化图表
       */

      initLineCharts() {
        this.chart = echarts.init(document.getElementById(this.id))
        let chartData = Object.assign({},this.chartData)
        let legendData = [] // 图例
        let xData = [] // x轴
        let seriesData = [] // x轴
        xData = this.objOfValueToArr(this.chartData.time.data)
        delete chartData.time

        for(let key in chartData){
          legendData.push(chartData[key].name)

          seriesData.push({
            name: chartData[key].name,
            type: 'bar',
            barWidth: '70%',
            data: Object.values(chartData[key].data)
          })
        }

        this.chart.setOption({
          color: ['#428EFE'],
          tooltip: {
            trigger: 'axis',
            axisPointer : {            // 坐标轴指示器，坐标轴触发有效
              type : 'shadow'        // 默认为直线，可选为：'line' | 'shadow'
            }
          },
          legend: {
            // top: 20,
            // data: legendData,
            // right: '4%',
            show:false
          },
          grid: {
            top:'30px',
            left: '2%',
            right: '2%',
            bottom: '3%',
            containLabel: true
          },
          xAxis: [{
            type: 'category',
            axisTick: {
              alignWithLabel: true
            },
            data: xData
          }],
          yAxis: [{
            type: 'value',
            minInterval:1
          }],
          series: seriesData
        })

      }
    },
  }
</script>

<style lang="">

</style>
